export default function useObject() {
  const areEquals = (object1: Record<string, unknown>, object2: Record<string, unknown>) => {
    const compare = (o: unknown) =>
      Object.entries(o)
        .sort()
        .map((i) => {
          if (i[1] instanceof Object) i[1] = compare(i[1])
          return i
        })
    return JSON.stringify(compare(object1)) === JSON.stringify(compare(object2))
  }
  const removeNull = (obj: Record<string, unknown>) => {
    return Object.fromEntries(Object.entries(obj).filter((entry) => !!entry[1]))
  }

  const hasNonNullValue = (obj) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== null) {
        return true
      }
    }
    return false
  }
  return { areEquals, removeNull, hasNonNullValue }
}
